<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-users"></i> User Group
      </Tab>
      <Tab tabid="tab-2" v-if="userHasReadPermission(PermissionTypes.UserPermissionTypes.permission)">
        <i class="far fa-lock-alt"></i> Permissions
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">
        <DataPageArea title="Details">
          <template slot="actionArea">
            <ActionDropMenu v-if="userHasUpdatePermission(PermissionTypes.UserPermissionTypes.userGroup)" class="float-right">
              <DropdownMenuItem @click="editUserGroup" icon="fa-pencil">Edit User Group</DropdownMenuItem>
              <DropdownMenuItem @click="deleteUserGroup" icon="fa-trash-alt">Delete User Group</DropdownMenuItem>
            </ActionDropMenu>
          </template>
          <template slot="dataArea">
            <DataItem title="Name"><i class="fas fa-users" :style="{'color': userGroupData.colourTag}"> </i> {{userGroupData.name}}</DataItem>
          </template>
        </DataPageArea>

        <div class="m-b-sm">
          <br>
        </div>
        
        <div class="row">
          <div class="col-lg-12">
            <h3>Users</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <StaticDataTable class="static-table-list">
              <template v-slot:body>
                <tr v-for="user in userGroupData.users" :key="user.id">
                  <td><Avatar :name="user.name" :size="28" :image="user.logoURL" /></td>
                  <td width="100%"><router-link :to="'/users/' + user.id">{{user.name}}</router-link></td>
                </tr>
              </template>
            </StaticDataTable>
          </div>
        </div>
      </TabPage>
      <TabPage tabid="tab-2">
        <div class="row">
          <div class="col-lg-12">
            <ActionDropMenu v-if="userHasUpdatePermission(PermissionTypes.UserPermissionTypes.permission)" class="float-right">
              <DropdownMenuItem @click="editPermissions" v-if="!editingPermissions" icon="fa-pencil">Edit Permissions</DropdownMenuItem>
              <DropdownMenuItem @click="resetPermissions" icon="fa-trash-undo">Reset Permissions</DropdownMenuItem>
            </ActionDropMenu>
            <h3>Permissions</h3>
          </div>
        </div>
        <FormGroup :form="permissionForm">
          <PermissionMatrix
            :permissionMap="userGroupData.permissions"
            @update="userGroupPermissions = $event"
            editMode="group"
            :editing="editingPermissions"
          />
          <div v-if="editingPermissions">
            <FormSubmit label="Update Permissions" :submitting="submittingPermissionUpdate" @cancelled="cancelPermissionEditing" @submitted="submitPermissionUpdate" />
          </div>
        </FormGroup>
      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import form from '@/mixins/form'
import TabbedBox from "@/components/layout/tabbedBox.vue"
import Tab from "@/components/layout/tab.vue"
import TabPage from "@/components/layout/tabPage.vue"
import StaticDataTable from "@/components/table/staticDataTable.vue"
import PermissionMatrix from '@/modules/users/components/permissionMatrix.vue'
import UserGroupEditDialog from '@/modules/users/views/userGroupEditDialog.vue'
import Avatar from '@/components/avatar'

export default {
  name: "UserGroup",
  mixins: [form],
  components: {
    TabbedBox,
    Tab,
    TabPage,
    StaticDataTable,
    PermissionMatrix,
    Avatar
  },
  data: () => {
    return {
      breadcrumbs: [
        { title: "Users", link: "/users" },
        { title: "User Groups" }
      ],
      userGroupData: {},

      // Permissions
      editingPermissions: false,
      submittingPermissionUpdate: false,
      permissionForm: {},
      userGroupPermissions: {}
    };
  },
  mounted() {
    this.requestData()
  },
  computed: {
  },
  methods: {
    requestData() {
      this.$apiService.userService.getUserGroup(this.$route.params.id).then(response => {
        this.$data.userGroupData = response.data;
        this.$data.userGroupPermissions = response.data.permissions

        this.$store.commit("page/setPageTitle", this.$data.userGroupData.name);
      })
    },
    editPermissions() {
      this.$data.editingPermissions = true
    },
    resetPermissions() {
      this.confirmDeleteMessage('Reset User Group Permissions?', 'Are you sure you want to reset this user group\'s permissions?')
      .then(success => {
        if(success) {
          this.$apiService.userService.resetUserGroupPermissions(this.$route.params.id)
          .then(response => {
            this.$data.editingPermissions = false
            this.successToast('Permissions Reset')
            this.requestData()
          })
        }
      })
    },
    cancelPermissionEditing() {
      this.editingPermissions = false
      this.permissionForm = {}

      // Refresh data to go back to correct data
      this.requestData()
    },
    submitPermissionUpdate() {
      this.submittingPermissionUpdate = true
      this.permissionForm = {}

      this.$apiService.userService.updateUserGroupPermissions(this.$route.params.id, { permissions: this.$data.userGroupPermissions })
      .then(response => {
        this.submittingPermissionUpdate = false
        this.$data.editingPermissions = false
        this.successToast('Permissions Updated')
      })
      .catch(err => {
        this.submittingPermissionUpdate = false
        this.$data.permissionForm = this.processFormResponse(err)
      })
    },
    editUserGroup() {
      this.displayModal(UserGroupEditDialog, { 
        userGroupId: this.$data.userGroupData.id
      },
      this.$data.userGroupData)
      .then((success) => {
        if(success) {
          this.successToast('User Group Updated')
          this.requestData()
        }
      })
    },
    deleteUserGroup() {
      this.confirmDeleteMessage('Delete User Group?', 'Are you sure you want to delete this user group?')
      .then(success => {
        if(success) {
          this.$apiService.userService.deleteUserGroup(this.$route.params.id).then(response => {
            this.successToast('User Group Deleted')
            this.$router.push(`/users/groups`)
          })
        }
      })
    }
  }
}

</script>